(function () {
  'use strict';

  var root = document.querySelector('[data-aks-b2b]');
  if (!root || root.dataset.aksInitialized === 'true') return;
  root.dataset.aksInitialized = 'true';

  var config = {
    whatsapp: (root.dataset.whatsappNumber || '').replace(/\D/g, ''),
    ga4: (root.dataset.ga4Id || '').trim(),
    meta: (root.dataset.metaPixelId || '').trim(),
    trackingEnabled: root.dataset.trackingEnabled === 'true'
  };
  var consent = { analytics: false, marketing: false };
  var scripts = { ga4: false, meta: false };
  var form = root.querySelector('[data-inquiry-form]');
  var intentField = root.querySelector('[data-inquiry-intent]');
  var intentCopy = root.querySelector('[data-form-intent-copy]');
  var status = root.querySelector('[data-form-status]');
  var contact = root.querySelector('[data-contact-section]');
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var query = new URLSearchParams(window.location.search);

  function campaignData() {
    return utmKeys.reduce(function (result, key) {
      if (query.get(key)) result[key] = query.get(key);
      return result;
    }, {});
  }

  function loadScript(src, id) {
    if (document.getElementById(id)) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = src;
    script.id = id;
    document.head.appendChild(script);
  }

  function startGA4() {
    if (!config.ga4 || scripts.ga4 || !consent.analytics) return;
    scripts.ga4 = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', config.ga4, { send_page_view: true });
    loadScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(config.ga4), 'aks-ga4');
  }

  function startMeta() {
    if (!config.meta || scripts.meta || !consent.marketing) return;
    scripts.meta = true;
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = true; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js'));
    window.fbq('init', config.meta);
    window.fbq('track', 'PageView');
  }

  function updateConsent() {
    if (!config.trackingEnabled || !window.Shopify || !window.Shopify.customerPrivacy) return;
    consent.analytics = Boolean(window.Shopify.customerPrivacy.analyticsProcessingAllowed());
    consent.marketing = Boolean(window.Shopify.customerPrivacy.marketingAllowed());
    startGA4();
    startMeta();
  }

  function initializeConsent() {
    if (!config.trackingEnabled || !window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) updateConsent();
    });
    document.addEventListener('visitorConsentCollected', updateConsent);
  }

  function track(name, data) {
    var payload = Object.assign({}, campaignData(), data || {});
    if (consent.analytics && window.gtag) window.gtag('event', name, payload);
    if (consent.marketing && window.fbq) {
      var metaEvent = name === 'whatsapp_inquiry_open' ? 'Lead' : 'CustomEvent';
      if (metaEvent === 'Lead') window.fbq('track', 'Lead', { content_name: payload.inquiry_intent || 'WhatsApp inquiry' });
      else window.fbq('trackCustom', name, payload);
    }
  }

  function setIntent(intent) {
    if (!intentField) return;
    intentField.value = intent;
    if (intentCopy) intentCopy.textContent = intent === 'catalogue' ? 'Request the private catalogue' : 'Start a new development';
    if (status) status.textContent = '';
  }

  root.querySelectorAll('[data-inquiry-cta]').forEach(function (button) {
    button.addEventListener('click', function () {
      var intent = button.dataset.inquiryCta;
      setIntent(intent);
      track('hero_cta_click', { cta_type: intent });
      contact.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(function () { form.querySelector('[name="name"]').focus({ preventScroll: true }); }, 450);
    });
  });

  root.querySelectorAll('[data-track-email]').forEach(function (link) {
    link.addEventListener('click', function () { track('email_click'); });
  });
  root.querySelectorAll('[data-track-whatsapp-direct]').forEach(function (link) {
    link.addEventListener('click', function () { track('whatsapp_direct_click'); });
  });

  if ('IntersectionObserver' in window && contact) {
    var viewed = false;
    new IntersectionObserver(function (entries, observer) {
      if (entries[0].isIntersecting && !viewed) { viewed = true; track('contact_section_view'); observer.disconnect(); }
    }, { threshold: 0.35 }).observe(contact);
  }

  if (form) {
    form.addEventListener('focusin', function () {
      if (!form.dataset.started) { form.dataset.started = 'true'; track('lead_form_start', { inquiry_intent: intentField.value }); }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.checkValidity()) {
        var invalid = Array.prototype.map.call(form.querySelectorAll(':invalid'), function (field) { return field.name; });
        track('lead_form_validation_error', { invalid_fields: invalid.join(',') });
        form.reportValidity();
        if (status) status.textContent = 'Please complete the required fields before continuing in WhatsApp.';
        return;
      }
      if (!config.whatsapp) {
        if (status) status.textContent = 'WhatsApp is not configured yet. Please use the email link instead.';
        return;
      }
      var values = new FormData(form);
      var intent = values.get('intent') === 'catalogue' ? 'the private product catalogue' : 'a new footwear development';
      var message = [
        'Hello AKS Footwear,',
        '',
        'I would like to discuss ' + intent + '.',
        '',
        'Name: ' + values.get('name'),
        'Company / brand: ' + values.get('company'),
        'Work email: ' + values.get('email'),
        'Target market: ' + values.get('market'),
        'Product direction: ' + values.get('product'),
        'Estimated quantity: ' + values.get('quantity'),
        'Target launch: ' + values.get('timeline'),
        values.get('message') ? 'Notes: ' + values.get('message') : ''
      ].filter(Boolean).join('\n');
      track('whatsapp_inquiry_open', { inquiry_intent: values.get('intent'), product_direction: values.get('product'), quantity_range: values.get('quantity'), market: values.get('market') });
      var url = 'https://wa.me/' + config.whatsapp + '?text=' + encodeURIComponent(message);
      var popup = window.open(url, '_blank', 'noopener,noreferrer');
      if (!popup) window.location.assign(url);
      if (status) status.textContent = 'WhatsApp is open. Please send the prefilled message there to complete your enquiry.';
    });
  }

  initializeConsent();
}());
